export default {
    namespaced: true,
    state: () => ({
        ipwhitelist: [],
        supported: {}
    }),
    mutations:
    {
        SET_IPWHITELIST(state, val) {
            state.ipwhitelist = val
        },
        SET_SUPPORTED(state, val)
        {
            state.supported = {...state.supported, ...val}
        }
    }
}